import { useLocation } from 'react-router-dom';
import { SEO } from './SEO';
import { seoConfig } from '../../data/seoConfig';

export function GlobalSEO() {
    const location = useLocation();
    const currentPath = location.pathname;

    const config = seoConfig[currentPath];

    if (!config) {
        return null;
    }

    return (
        <SEO
            title={config.title}
            description={config.description}
            keywords={config.keywords}
        />
    );
}
